<div class="pc-swatches" [class.group]="saveAsGenericGroup">
  @for (c of colors; track c.value) {
    <button
      type="button"
      class="pc-swatch"
      [class.sel]="color === c.value"
      [style.background]="c.value"
      [attr.aria-label]="c.class"
      [attr.aria-pressed]="color === c.value"
      (click)="color = c.value">
    </button>
  }
</div>
